import React, { useEffect, useRef, useState } from 'react';
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { DefaultConsent } from '../../utils/constants';
import Style from './style.module.scss';

const CookieBand = ({ setIsModalVisible, setIsActive, isActive }) => {
  const { t } = useTranslation();
  const [cookies, setCookie] = useCookies();
  const cookieBandRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [showBand, setShowBand] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowBand(true);
    }, 1000);
  }, []);

  const checkCookiesChange = () => {
    if (cookies.cc_cookie.level.indexOf('ads') !== -1) {
      return {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        reklam: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
      };
    }
    return {
      ...DefaultConsent,
    };
  };

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    if (!window.gtag) {
      window.gtag = function gtag() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
      };
    }

    let consentArguments = { ...DefaultConsent };
    if (cookies?.cc_cookie) {
      consentArguments = checkCookiesChange();
    }

    window.gtag('consent', 'default', consentArguments);
  }, []);

  useEffect(() => {
    if (!cookies) return;

    if (!cookies.cc_cookie && !cookies?.isHybrid) {
      setIsVisible(true);
      setTimeout(() => setIsActive(true), 1100);
      window.isConsentActive = () => false;
    } else {
      const level = cookies.cc_cookie?.level || [];
      const hasAdsConsent = level?.includes('ads');
      const hasNecessaryConsent = level?.includes('necessary');

      window.isConsentActive = (type) => {
        if (type === 'ads') return hasAdsConsent;
        if (type === 'necessary') return hasNecessaryConsent;
        return false;
      };
    }
  }, [cookies]);

  const acceptCookies = (type) => {
    setCookie(
      'cc_cookie',
      JSON.stringify({
        level: type === 'accept' ? ['necessary', 'ads'] : ['necessary'],
        revision: 0,
        data: null,
        rfc_cookie: false,
      }),
      {
        path: '/',
        domain: `.${window.location.hostname}`,
        secure: true,
        sameSite: 'Lax',
        expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
        encode: (value) => value,
      }
    );

    const consentArguments =
      type === 'accept'
        ? {
            ad_storage: 'granted',
            analytics_storage: 'granted',
            reklam: 'granted',
            ad_user_data: 'granted',
            ad_personalization: 'granted',
          }
        : {
            ...DefaultConsent,
          };

    if (window.gtag) {
      window.gtag('consent', 'update', consentArguments);
    }

    window.dataLayer.push({
      event: 'cookieConsentUpdated',
      consent_status: type === 'accept' ? 'granted' : 'denied',
    });

    setTimeout(() => {
      if (window.gtag) {
        window.gtag('event', 'page_view', {
          page_location: window.location.href,
          page_path: window.location.pathname,
        });
      }
    }, 100);

    setIsActive(false);
    setTimeout(() => setIsVisible(false), 600);
  };

  if (!isVisible) return null;

  return (
    <div
      ref={cookieBandRef}
      className={`${Style.cookieBand} ${showBand ? Style.showBand : ''} ${isActive ? Style.active : ''}`}
    >
      <div className={Style.textArea}>
        <div className={Style.text}>
          <Trans
            i18nKey="cookiePopup.description"
            components={[
              <button key={1} type="button" onClick={() => acceptCookies('decline')}>
                {1}
              </button>,
              <Link key={2} to={t('routes.cookiePolicy')}>
                {2}
              </Link>,
            ]}
          />
        </div>
      </div>
      <div className={Style.line}></div>
      <div className={Style.buttons}>
        <button type="button" onClick={() => setIsModalVisible(true)}>
          {t('cookiePopup.cookieOptions')}
        </button>
        <button type="button" onClick={() => acceptCookies('accept')}>
          {t('cookiePopup.approve')}
        </button>
      </div>
    </div>
  );
};

export default CookieBand;
